module.exports = __webpack_public_path__ + "2192c4b9b2880d11ba6ad7bb272f7558.svg";